import * as types from './charge-activity-mutation-types';

export default {
  [types.CHARGE_ACTIVITY](state, payload) {
    state.charge_activity = payload;
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/charge-activity/charge-activity-mutations.js